<template>
  <div class="flex items-baseline timer mr-5 hidden md:block">
    <div class="flex gap-2 items-center">
      <vs-button
        color="primary"
        type="filled"
        @click="(turnedOn) ? stop() : start()"
        :icon="(turnedOn) ? 'pause alarm' : 'play_arrow alarm'"
      >
        {{ formattedElapsedTime.replace(/,/g, '') }}
      </vs-button>
      <feather-icon
        v-show="!turnedOn && time_stamp > 0"
        icon="RefreshCwIcon"
        svg-classes="w-6 h-6 text-primary cursor-pointer"
        @click="reset"
      />
    </div>
  </div>
</template>

<script>
import Mixin from "@/views/mixin/mixin";
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

export default {
  name: "Timer",

  mixins: [Mixin],

  props: {
    time:{
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      turnedOn    : false,
      time_stamp  : this.time,
      time_normal : undefined,
      timerWorker : undefined,
    };
  },

  computed: {
    formattedElapsedTime: {
      get() {
          let time_stamp = this.time_stamp / 3600
          let duration   = moment.duration(time_stamp, "hours").format("HH:mm:ss")
          if (!duration.includes(':') || this.time_stamp === 0) {
            const date = new Date(null)
            date.setSeconds(this.time_stamp)
            const utc = date.toUTCString()
            return utc.substr(utc.indexOf(":") - 2, 8)
          } else {
            return time_stamp < 1 ? '00:' + duration : duration
          }
      },
      set(newTime) {
         this.time_stamp = newTime
      }
    }
  },

  methods: {
    start() {
      this.timerWorker.postMessage('start')
      this.turnedOn = true
      this.$emit('startTime')
    },

    stop() {
      this.timerWorker.postMessage('stop')
      this.$emit('Timer', this.formattedElapsedTime.replace(/,/g, ''), this.time_stamp)
      this.turnedOn = false
    },

    reset() {
      this.timerWorker.postMessage('reset')
      this.time_stamp = 0
      this.formattedElapsedTime = 0
    },

    onTimerWorkerUpdated(e) {
      this.time_stamp = e.data
    },

    onTimerWorkerFailed(e) {
      console.error(e.data)
    },
  },

  mounted() {
    this.timerWorker = new Worker('../timerWorker.js')
    this.timerWorker.onmessage = this.onTimerWorkerUpdated
    this.timerWorker.onerror = this.onTimerWorkerFailed
  },

  unmounted() {
    this.timerWorker.terminate()
  },
}
</script>

<style>
.vs-button-text.vs-button--text {
  min-width: 60px;
  font-size: 1em;
}
@media (max-width: 320px) {
  .timer{
    margin-right: 1.75em;
  }
  .timer button{
    min-width: 117px;
  }
  .timer .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large){
    padding: 9px;
  }
}
</style>
